export const NdflDeductionVer = {
  androidVer: '3.69',
  iosVer: '5.94',
};
